module.exports = __webpack_public_path__ + "static/media/0024_IMG_FE_LES_MURS_P21_UNI_CARVAO_VERTICALE.09d5f024.webp";